
import { defineComponent } from "vue";
import gql from "graphql-tag";
import noneIcon from "@/assets/svg-icons/None.svg";
import draftIcon from "@/assets/svg-icons/Draft.svg";

export default defineComponent({
	name: "SystemCategoryIcon",
	props: {
		systemCategoryId: {
			type: Number || null,
			required: true,
		},
		showBadge: {
			type: Boolean,
			default: false,
		},
		inventoryItemId: {
			type: Number || null,
			required: false,
		},
	},
	data() {
		return {
			infinite: false,
			loading: false,
			failed: false,
		};
	},
	methods: {
		onError() {
			this.failed = true;
			this.loading = false;
		},
		async getInventoryListingById(inventoryItemId: Number) {
			try {
				const res = await this.$apollo.query({
					query: gql`
						query GetInventoryListing($inventoryItemId: Int!) {
							inventoryListings(where: { inventoryItemId: { eq: $inventoryItemId } }) {
								items {
									inventoryItemId
									systemCategoryId
									styleCode
									description
									infiniteInventory
									stockItems
									onHand
									committed
								}
							}
						}
					`,
					variables: {
						inventoryItemId: inventoryItemId,
					},
					fetchPolicy: "no-cache",
				});

				let item =
					res.data.inventoryListings?.items.length === 1
						? res.data.inventoryListings?.items[0]
						: null;

				this.infinite = item?.infiniteInventory ?? false;
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
	},
	computed: {
		// Draft items that are NOT part of a package carry the placeholder category (20) and item id -1.
		// Draft items inside a package have their real category and use its icon like any other line.
		isDraft(): boolean {
			return this.inventoryItemId === -1 && this.systemCategoryId === 20;
		},
		iconUrl(): string | null {
			return this.isDraft ? null : this.$systemCategories.getCategoryIcon(this.systemCategoryId);
		},
		src(): string {
			if (this.isDraft) return draftIcon;
			if (this.iconUrl && !this.failed) return this.iconUrl;
			return noneIcon;
		},
		name(): string {
			if (this.isDraft) {
				return "Draft Item";
			}
			return this.$systemCategories.getName(this.systemCategoryId);
		},
	},
	watch: {
		iconUrl: {
			immediate: true,
			handler(url: string | null) {
				// Only remote icons need a placeholder; the built-ins are bundled and paint immediately.
				this.failed = false;
				this.loading = !!url;
			},
		},
	},
	async mounted() {
		if (this.inventoryItemId) {
			await this.getInventoryListingById(this.inventoryItemId);
		}
	},
});
